import React, { useContext, useEffect, useState } from "react";
import { languages } from "../Vocabulary/Vocabulary";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    JSON.parse(localStorage.getItem("select-language")) || undefined
  );
  
  const [account, setAccount] = useState();
  const [loggedUser, setLoggedUser] = useState(
    JSON.parse(localStorage.getItem("editor-user")) || undefined
  );
  const [typeButton, setTypeButton] = useState(
    loggedUser === undefined ? 0 : loggedUser.typeButton
  );
  const [colorButton, setColorButton] = useState(
    loggedUser === undefined ? "#CCC" : loggedUser.colorButton
  );
  const [letterSize, setLetterSize] = useState();
  const [boldItalic, setBoldItalic] = useState([]);
  const [controlEmail, setControlEmail] = useState(undefined);
  const [baseUrl] = useState("https://data.nadzor.app/api");
  const [apiKey, setApiKey] = useState(
    JSON.parse(localStorage.getItem("api-key")) || ""
  );
  const [currentChat, setCurrentChat] = useState(null);
  const [entryKey, setEntryKey] = useState("");
  const [location, setLocation] = useState();
  const [activeIconsMiddle, setActiveIconsMiddle] = useState([]);
  const [openAddLink, setOpenAddLink] = useState(false);
  const [newLinks, setNewLinks] = useState([]);
  const [copy, setCopy] = useState({ index: null, value: false });
  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [userReload, setUserReload] = useState(false);
  const [fontSize, setFontSize] = useState();
  const [fontStyle, setFontStyle] = useState();
  const [isFromHome, setIsFromHome] = useState(false);
  const [isFromFirstTrustContact, setIsFromFirstTrustContact] = useState(false); 
  const [fromEnterCode, setFromEnterCode] = useState(false);
  console.log(typeButton);

  const values = {
    fromEnterCode,
    setFromEnterCode,
    isFromFirstTrustContact,
    setIsFromFirstTrustContact,
    isFromHome,
    setIsFromHome,
    fontStyle,
    setFontStyle,
    fontSize,
    setFontSize,
    boldItalic,
    setBoldItalic,
    letterSize,
    setLetterSize,
    typeButton,
    setTypeButton,
    userReload,
    setUserReload,
    selectedLanguage,
    setSelectedLanguage,
    loggedUser,
    setLoggedUser,
    baseUrl,
    account,
    setAccount,
    apiKey,
    setApiKey,
    location,
    setLocation,
    entryKey,
    setEntryKey,
    currentChat,
    setCurrentChat,
    activeIconsMiddle,
    setActiveIconsMiddle,
    controlEmail,
    setControlEmail,
    openAddLink,
    setOpenAddLink,
    newLinks,
    setNewLinks,
    copy,
    setCopy,
    isAndroid,
    setIsAndroid,
    isIOS,
    setIsIOS,
    colorButton,
    setColorButton,
  };

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
